var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ib-dialog",
    {
      staticClass: "comp-dialog",
      attrs: { autoclose: "", width: "1356px", height: "100%" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c("template", { slot: "default" }, [
        _vm.showQuoteDetails === "new"
          ? _c("div", { staticClass: "iframe-headers" }, [
              _c("div", { staticClass: "iframe-header-info start-16" }, [
                _vm.reloadIframe
                  ? _c("iframe", {
                      staticStyle: { border: "none" },
                      attrs: {
                        src: _vm.iframeURL,
                        width: "100%",
                        height: "100%",
                        title: "Contract Details",
                        id: "contractFrame",
                      },
                    })
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _c("div", [
          _c(
            "span",
            {
              ref: "reload",
              staticClass: "icon-close",
              on: { click: _vm.close },
            },
            [
              _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                _c("path", {
                  attrs: { d: "M12 0a12 12 0 1012 12A12 12 0 0012 0z" },
                }),
                _c("path", {
                  attrs: {
                    d: "M13.414 12l3.293 3.293a1 1 0 11-1.414 1.414L12 13.414l-3.293 3.293a1 1 0 11-1.414-1.414L10.586 12 7.293 8.707a1 1 0 111.414-1.414L12 10.586l3.293-3.293a1 1 0 111.414 1.414z",
                    fill: "#fff",
                  },
                }),
              ]),
            ]
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }